import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getCertificationListAPI } from "../../apiConfig/apiCall";

export const getCertificationList = createAsyncThunk('getCertificationList', async () => {
    const response = await getCertificationListAPI();
    return response.data;
});

const getCertificationListSlice = createSlice({
    name: "getCertificationList",
    initialState: {
        isLoading: false,
        isError: false,
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(getCertificationList.pending, (state) => {
            state.isLoading = true;
            state.isError = false;
        });
        builder.addCase(getCertificationList.fulfilled, (state, action) => {
            state.isLoading = false;
            state.data = action.payload;
        });
        builder.addCase(getCertificationList.rejected, (state) => {
            state.isError = true;
            state.isLoading = false;
        });
    }
});

export default getCertificationListSlice.reducer;